export default __webpack_public_path__ + "static/media/miniLogo.38846f8b.svg";